import { useEffect } from 'react';
import { pushScope, registerBindings, type KeyBinding, type KeyScope } from './keymap';

/** Push a key scope while the component is mounted. */
export function useKeyScope(scope: KeyScope): void {
  useEffect(() => pushScope(scope), [scope]);
}

/**
 * Register bindings while the component is mounted. `deps` re-registers when
 * the binding closures need fresh captured values; prefer reading state via
 * `getState()` inside `run` so deps can stay empty.
 */
export function useKeyBindings(factory: () => KeyBinding[], deps: unknown[] = []): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => registerBindings(factory()), deps);
}
